module.exports = __webpack_public_path__ + "static/media/instagram.d499c206.png";